import React from "react"
import g from "glamorous"
import { css } from "glamor"
import Link from "gatsby-link"
import { rhythm } from "../utils/typography"
import mediaQueries from "../utils/breakpoints"

const NavLinkStyle = css({
    textDecoration: `none`,
    textTransform: `uppercase`,
    margin: `0 1.5em`,
    ':last-child': {
        marginRight: 0
    }
})

const SocialNavLinkStyle = css({
    margin: `0 2.75em`,
    textDecoration: `none`,
    textTransform: `uppercase`,
    ':last-child': {
        marginRight: 0
    }
})

const MenuContainer = g.div({
    position: `relative`,
    textAlign: `right`,
    float: `right`,
    paddingTop: rhythm(0.5),
    [mediaQueries.phone]: {
        float: `none`,
        textAlign: `center`,
        position: `fixed`,
        top: 0,
        left: 0,
        width: `100vw`,
        height: `100vh`,
        background: `white`,
        zIndex: 1000,
        display: `flex`,
        flexDirection: `column`,
        justifyContent: `center`,
        alignItems: `center`,
        opacity: 0,
        pointerEvents: `none`,
        transition: `all 0.25s linear`,
        zIndex: 1000
    }
})

const MenuOpen = css({
    [mediaQueries.phone] : {
        opacity: `1 !important`,
        pointerEvents: `all !important`,
        overflow: `hidden !important`,
        maxWidth: `100vw !important`,
        maxHeight: `100vh !important`
    }
})

const SocialContainer = g.div({
    position: `absolute`,
    right: `0`,
    top: `7em`,
    fontSize: `0.678125em`,
    [mediaQueries.phone]: {
        float: `none`,
        textAlign: `center`,
        top: `4em`
    }
})

const ActiveLinkStyle = css({
    position: `relative`,
    ':after': {
        position: `absolute`,
        top: `2em`,
        left: `50%`,
        transform: `translateX(-50%)`,
        content: ` `,
        width: `2em`,
        height: `4px`,
        background: `black`
    },
    [mediaQueries.phone]: {
        ':after': {
            display: `none`
        }
    }
})

const MenuToggle = g.div({
    position: `absolute`,
    top: `-2.75em`,
    fontSize: `0.75em`,
    left: `50%`,
    transform: `translateX(-50%) translateY(-50%)`,
    cursor: `pointer`,
    display: `none`,
    zIndex: 1001,
    ':hover,:active,:focus': {
        opacity: 0.8
    },
    [mediaQueries.phone]: {
        display: `block`
    }
})

const getNavIsActive = (match, location) => {
    if (!match)
        return false
    return location.pathname === match.path || location.pathname.startsWith('/work/')
}

const HeaderStyle = css({
    marginBottom: rhythm(2),
    display: `inline-block`,
    fontStyle: `normal`,
    position: `relative`,
    zIndex: 1001,
    [mediaQueries.phone]: {
        width: `100%`,
        display: `block`,
        textAlign: `center`
    }
})

const toggleMenu = () => {
    //console.info(MenuContainer.className)
    const body = document.getElementsByTagName('body')[0]
    const menu = document.getElementsByClassName('menu')[0]
    body.classList.toggle(MenuOpen);
    menu.classList.toggle(MenuOpen);
}

const menuClicked = () => {
    const body = document.getElementsByTagName('body')[0]
    const menu = document.getElementsByClassName('menu')[0]
    menu.classList.remove(MenuOpen);   
    body.classList.remove(MenuOpen);   
}

export default () =>
    <g.Nav position={`relative`} marginBottom={`2em`}>
        <MenuToggle onClick={ toggleMenu }>Menu</MenuToggle>
        <Link to={`/`}>
            <h1 className={HeaderStyle}>
                <g.Span display={`none`}>
                    Geof Ramsay
                </g.Span>
                <img src="/images/logo.svg" alt="GeofRamsay Logo" style={{width: `8.67em`}}/>
            </h1>
        </Link>
        <MenuContainer className="menu">
            <Link activeClassName={ActiveLinkStyle} className={NavLinkStyle} to={`/`} isActive={getNavIsActive} onClick={menuClicked}>
                Work
            </Link>
            <Link activeClassName={ActiveLinkStyle} className={NavLinkStyle} to={`/about/`} onClick={menuClicked}>
                About
            </Link>
            <Link activeClassName={ActiveLinkStyle} className={NavLinkStyle} to={`/contact/`} onClick={menuClicked}>
                Contact
            </Link>
        </MenuContainer>
        <SocialContainer>
            <a href="https://www.instagram.com/geoframsay/?hl=en" target="_blank" className={SocialNavLinkStyle}>Instagram</a>
        </SocialContainer>
    </g.Nav>

//export default Navigation


// WEBPACK FOOTER //
// ./src/components/navigation.jsx